import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnTextField,
  columnNumberField,
  columnPriceField,
} from "utils/tables-utils";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

export default function PedidoDetailsItems({ items }) {
  const itemsColumnModel = [
    columnTextField({
      dataField: "UrlFoto",
      text: "Imagem",
      headerAlign: "center",
      align: "center",
      formatter: (_, row) => (
        <ImagePlaceholder
          alt="Imagem do produto"
          src={row.UrlFoto}
          width={64}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row.IdProduto}`}
        />
      ),
    }),
    columnNumberField({
      dataField: "SequencialItem",
      text: "Item Sequencial",
      align: "center",
    }),
    columnTextField({
      dataField: "SituacaoItemPedido",
      text: "Situação",
      align: "center",
    }),
    columnTextField({
      dataField: "LinhaProduto",
      text: "Linha",
      align: "center",
    }),
    columnTextField({
      dataField: "ColecaoProduto",
      text: "Coleção",
      align: "center",
    }),
    columnNumberField({
      dataField: "IdProduto",
      text: "Produto",
      align: "center",
    }),
    columnTextField({
      dataField: "DescricaoProduto",
      text: "Descrição",
    }),
    columnTextField({
      dataField: "NomeProduto",
      text: "Nome Produto",
    }),
    columnTextField({
      dataField: "CodCorProduto",
      text: "Cor",
    }),
    columnTextField({
      dataField: "TamanhoProduto",
      text: "Tamanho",
      align: "center",
    }),
    columnNumberField({
      dataField: "QtdPedida",
      text: "Qtd Pedida",
      align: "center",
    }),
    columnNumberField({
      dataField: "QtdAlocada",
      text: "Qtd Alocada",
      align: "center",
    }),
    columnNumberField({
      dataField: "QtdFaturada",
      text: "Qtd Faturada",
      align: "center",
    }),
    columnNumberField({
      dataField: "QtdEntregue",
      text: "Qtd Entregue",
      align: "center",
    }),
    columnPriceField({
      dataField: "PrecoUnitario",
      text: "Preço Unitário",
      align: "end",
    }),
    columnTextField({
      dataField: "DataEstoque",
      text: "Data Estoque",
      align: "end",
    }),
    columnTextField({
      dataField: "Observacao",
      text: "Observação",
    }),
    columnTextField({
      dataField: "OCLojista",
      text: "OC Lojista",
      align: "center",
    }),
  ];

  return (
    <ToolkitTable
      dataTable={items}
      columnModel={itemsColumnModel}
      keyField="ItemSequencial"
      pagination={false}
      style={{
        boxShadow: "none",
      }}
    />
  );
}
